import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function PiggyBank({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M10.6667 4.66665C10.6667 3.56208 11.5622 2.66665 12.6667 2.66665C13.7713 2.66665 14.6667 3.56208 14.6667 4.66665H16.0001C16.0001 2.8257 14.5077 1.33331 12.6667 1.33331C10.8258 1.33331 9.33342 2.8257 9.33342 4.66665H10.6667Z"
        fill={iconColor}
      />
      <Path
        d="M4.82469 4.71383C4.62812 3.92755 5.50242 3.31142 6.17678 3.76099L9.53526 5.99998H14.3474C17.1982 5.99998 19.6963 7.90803 20.4464 10.6584C20.6172 11.2846 20.6882 11.9232 20.6651 12.5534C21.4427 12.2794 22.0001 11.5381 22.0001 10.6666H23.3334C23.3334 12.3548 22.0785 13.7499 20.4506 13.9698C20.1672 15.0194 19.6132 15.9963 18.8176 16.792L18.0001 17.6095V21.3333C18.0001 21.7015 17.7016 22 17.3334 22H14.6667C14.2986 22 14.0001 21.7015 14.0001 21.3333V18H10.0001V21.3333C10.0001 21.7015 9.7016 22 9.33342 22H6.66675C6.29856 22 6.00008 21.7015 6.00008 21.3333V17.9925C4.88072 17.9126 3.89568 17.2007 3.47437 16.1474L2.88206 14.6666H1.33341C0.965225 14.6666 0.666748 14.3682 0.666748 14V9.99998C0.666748 9.63179 0.965225 9.33331 1.33341 9.33331H3.013L4.11793 7.95215C4.84594 7.04214 5.10734 5.84442 4.82469 4.71383ZM6.26575 5.42277C6.31259 6.62868 5.92723 7.8249 5.15908 8.78508L3.85399 10.4164C3.72748 10.5746 3.53594 10.6666 3.33341 10.6666H2.00008V13.3333H3.33341C3.60602 13.3333 3.85116 13.4993 3.9524 13.7524L4.71234 15.6522C4.95741 16.2649 5.5508 16.6666 6.21066 16.6666C6.83074 16.6666 7.33342 17.1693 7.33342 17.7894V20.6666H8.66675V17.3333C8.66675 16.9651 8.96523 16.6666 9.33342 16.6666H14.6667C15.0349 16.6666 15.3334 16.9651 15.3334 17.3333V20.6666H16.6667V17.3333C16.6667 17.1565 16.737 16.9869 16.862 16.8619L17.8748 15.8492C19.1406 14.5833 19.6311 12.7363 19.1601 11.0092C18.5682 8.83894 16.5969 7.33331 14.3474 7.33331H9.33342C9.2018 7.33331 9.07313 7.29435 8.96362 7.22135L6.26575 5.42277Z"
        fill={iconColor}
      />
    </Svg>
  );
}
